import { render } from "./relatedPost.vue?vue&type=template&id=9c33d978&scoped=true"
import script from "./relatedPost.vue?vue&type=script&lang=js"
export * from "./relatedPost.vue?vue&type=script&lang=js"

import "./relatedPost.vue?vue&type=style&index=0&id=9c33d978&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c33d978"]])

export default __exports__